import { TagPicker, useOrganizationTags } from "@/tags"
import { Tag } from "lucide-react"

import { isFilterSectionDisabled } from "@/components/filters/filterSectionVisibility"
import { FilterTrigger } from "@/components/filters/FilterTrigger"
import { useFilterSectionHover } from "@/components/filters/useFilterSectionHover"

import { useRunsFilter } from "../../contexts/RunsFilterContext"
import type { FilterSectionProps } from "../../types/filters"

/**
 * Tag multi-select section of the Simulated filter menu.
 */
export const TagsFilterSection: React.FC<FilterSectionProps> = ({
  isOpen,
  onToggle,
  filterEnabled,
}) => {
  const { tagFilters, setTagFilters } = useRunsFilter()
  const { isError, isLoading, suggestions } = useOrganizationTags({
    enabled: filterEnabled,
  })
  const isDisabled = isFilterSectionDisabled({
    activeFilterCount: tagFilters.length,
    isDeferred: filterEnabled === false,
    isError,
    isLoading,
    optionCount: suggestions.length,
  })
  const hoverProps = useFilterSectionHover({
    isOpen,
    onToggle,
    disabled: isDisabled,
  })

  return (
    <TagPicker
      selectedTags={tagFilters}
      onSelectedTagsChange={setTagFilters}
      isOpen={isOpen}
      restoreFocusOnClose={false}
      // The menu reports the state it wants; the parent menu owns which row is
      // expanded and only knows how to toggle.
      onOpenChange={(next) => {
        if (!isDisabled && next !== isOpen) {
          onToggle()
        }
      }}
      enabled={filterEnabled}
      isDeferred={filterEnabled === false}
      side="right"
      align="start"
      trigger={
        <FilterTrigger
          label="Tags"
          icon={<Tag className="w-4 h-4" />}
          isActive={tagFilters.length > 0}
          disabled={isDisabled}
          {...hoverProps}
        />
      }
    />
  )
}
